var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "floatingButtonStyle" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "100px", model: _vm.datas, size: "small" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "按钮描述" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入按钮文字",
                  maxlength: "12",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.datas.btnText,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "btnText", $$v)
                  },
                  expression: "datas.btnText",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "按钮宽度" } },
            [
              _c("el-input-number", {
                attrs: { min: 20, step: 1, size: "small" },
                model: {
                  value: _vm.datas.buttonWidth,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "buttonWidth", $$v)
                  },
                  expression: "datas.buttonWidth",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit-tip" }, [_vm._v("px")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "按钮高度" } },
            [
              _c("el-input-number", {
                attrs: { min: 20, step: 1, size: "small" },
                model: {
                  value: _vm.datas.buttonHeight,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "buttonHeight", $$v)
                  },
                  expression: "datas.buttonHeight",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit-tip" }, [_vm._v("px")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "圆角" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.datas.isRound,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "isRound", $$v)
                  },
                  expression: "datas.isRound",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "field-tip" }, [
                _vm._v(_vm._s(_vm.datas.isRound ? "胶囊圆角" : "直角")),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "水平位置" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.datas.position,
                    callback: function ($$v) {
                      _vm.$set(_vm.datas, "position", $$v)
                    },
                    expression: "datas.position",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "left" } }, [
                    _vm._v("左"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: "center" } }, [
                    _vm._v("中"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: "right" } }, [
                    _vm._v("右"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "距底部" } },
            [
              _c("el-input-number", {
                attrs: { min: 0, max: 100, step: 1, size: "small" },
                model: {
                  value: _vm.datas.bottomOffset,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "bottomOffset", $$v)
                  },
                  expression: "datas.bottomOffset",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit-tip" }, [
                _vm._v("%（屏幕宽度）"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.datas.position !== "center"
            ? _c(
                "el-form-item",
                { attrs: { label: "距侧边" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 50, step: 1, size: "small" },
                    model: {
                      value: _vm.datas.sideOffset,
                      callback: function ($$v) {
                        _vm.$set(_vm.datas, "sideOffset", $$v)
                      },
                      expression: "datas.sideOffset",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "unit-tip" }, [
                    _vm._v("%（屏幕宽度）"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "透明度" } },
            [
              _c("el-slider", {
                attrs: {
                  min: 0,
                  max: 100,
                  step: 1,
                  "show-input": "",
                  "input-size": "mini",
                },
                model: {
                  value: _vm.datas.opacity,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "opacity", $$v)
                  },
                  expression: "datas.opacity",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "按钮背景颜色" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.backgroundColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "backgroundColor", $$v)
                  },
                  expression: "datas.backgroundColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "按钮背景图片" } }, [
            _c("div", { staticClass: "upload-area" }, [
              _c("input", {
                ref: "bgFileInput",
                staticStyle: { display: "none" },
                attrs: { type: "file", accept: "image/*" },
                on: { change: _vm.handleFileChange },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "image-preview",
                  on: { click: _vm.handleImageClick },
                },
                [
                  _vm.datas.backgroundImg
                    ? _c("i", {
                        staticClass: "el-icon-delete-solid delete-btn",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleRemoveFile($event)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.datas.backgroundImg
                    ? _c("img", {
                        staticClass: "preview-img",
                        attrs: {
                          src: _vm.resPath + _vm.datas.backgroundImg,
                          alt: "背景图片",
                        },
                      })
                    : _c("div", { staticClass: "image-placeholder" }, [
                        _c("i", { staticClass: "el-icon-picture-outline" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("点击上传图片")]),
                      ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "upload-tip" }, [
              _vm._v("不传则使用背景色；"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "文字颜色" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.textColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "textColor", $$v)
                  },
                  expression: "datas.textColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景宽度" } },
            [
              _c("el-input-number", {
                attrs: { min: 0, step: 1, size: "small" },
                model: {
                  value: _vm.datas.bgWidth,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "bgWidth", $$v)
                  },
                  expression: "datas.bgWidth",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit-tip" }, [
                _vm._v("px（0 为自适应）"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景高度" } },
            [
              _c("el-input-number", {
                attrs: { min: 0, step: 1, size: "small" },
                model: {
                  value: _vm.datas.bgHeight,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "bgHeight", $$v)
                  },
                  expression: "datas.bgHeight",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit-tip" }, [
                _vm._v("px（0 为自适应）"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景颜色" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.bgColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "bgColor", $$v)
                  },
                  expression: "datas.bgColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "跳转链接" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入小程序页面路径，如 /pages/index/index",
                  clearable: "",
                },
                model: {
                  value: _vm.datas.http,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "http", $$v)
                  },
                  expression: "datas.http",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }